const CarRoutes = {
  createCarBooking: "/createCarBooking",
  getCarBooking: "/getCarBooking",
  updateCarBooking: "/updateCarBooking",
  deleteCarBooking: "/deleteCarBooking",
  getCarService: "/getCarService",
  assignDriver: "/assignDriver",
  deleteCarService: "/deleteCarService",
  updateCarService: "/updateCarService",
};

export default CarRoutes;
